import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/interface-favorite-award.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M216 96a88 88 0 1 0-144 67.83V240a8 8 0 0 0 11.58 7.16L128 225l44.43 22.21a8.1 8.1 0 0 0 3.57.79 8 8 0 0 0 8-8v-76.17A87.85 87.85 0 0 0 216 96M56 96a72 72 0 1 1 72 72 72.08 72.08 0 0 1-72-72m112 131.06-36.43-18.21a8 8 0 0 0-7.16 0L88 227.06v-52.69a87.89 87.89 0 0 0 80 0ZM128 152a56 56 0 1 0-56-56 56.06 56.06 0 0 0 56 56m0-96a40 40 0 1 1-40 40 40 40 0 0 1 40-40" }, null, -1)])]);
}
var interface_favorite_award_default = { render };
//#endregion
export { interface_favorite_award_default as default, render };

//# sourceMappingURL=interface-favorite-award.svg.js.map